// 判断partnerModeType 1SMB() 2EBG 3互联网 4运营商
export const checkPartnerModeType = (partnerType) => {
  if (["SUB","VAD","YP","JP"].includes(partnerType)) {
    return 1
  } else if (["RAD", "RDP", "RGP", "RSP", "RCP"].includes(partnerType)) {
    return 2
  } else if (["CBGRCSP", "RFFP"].includes(partnerType)) {
    return 3
  } else if (["TBURCSP", "RCAD", "RCAP"].includes(partnerType)) {
    return  4
  }
}



// WEBPACK FOOTER //
// ./src/views/enterpriseNetwork/index.js